import React from 'react';
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M100.001-140.001V-200h759.998v59.999H100.001zm40-115.385v-244.613H240v244.613h-99.999zm193.077 0v-444.613h99.998v444.613h-99.998zm193.461 0v-324.613h99.998v324.613h-99.998zm193.461 0v-564.613h99.999v564.613H720z"></path>
    </svg>;
}
export default Icon;